if (!customElements.get("class-toggler")) {
  class ClassToggler extends HTMLElement {
    constructor() {
      super();
      this.triggers = this.querySelectorAll("[data-element-to-toggle]");
      this.classToToggle = this.getAttribute("data-class-to-toggle");
      this.activeTriggerClass = "active";
    }

    connectedCallback() {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.toggleHandler.bind(this));
      });
      document.addEventListener('thumbnail-changed', (e) => {
        if (window.innerWidth > 980) return;
        
        let triggerElement = false
        this.triggers.forEach((trigger) => {
          if(trigger.id == e.detail.slide?.querySelector('[data-element-to-toggle')?.id) {
            triggerElement = trigger;
          }
        });

        if (!triggerElement) return;

        const elementToToggle = document.querySelector(
          triggerElement.getAttribute("data-element-to-toggle")
        );
        this.toggleChildClass(elementToToggle, triggerElement);
      })
    }

    toggleHandler(event) {
      const triggerElement = event.currentTarget;
      const elementToToggle = document.querySelector(
        triggerElement.getAttribute("data-element-to-toggle")
      );
      this.toggleChildClass(elementToToggle, triggerElement);
    }

    toggleChildClass(elementToToggle, triggerElement) {
      if (!elementToToggle || !this.classToToggle) {
        console.error(
         `Element to toggle (${triggerElement.getAttribute("data-element-to-toggle")}) or class to toggle (${this.classToToggle}) not found or invalid.`
        );
        return;
      }
      this.triggers.forEach((trigger) => {
        if (trigger.id == triggerElement.id) {
          triggerElement.classList.toggle("active");
          elementToToggle.classList.toggle(this.classToToggle);
        } else {
          trigger.classList.remove("active");
          const activeElement = document.querySelector(
            trigger.getAttribute("data-element-to-toggle") + '.' + this.classToToggle
          );
          if (activeElement) {
            activeElement.classList.remove(this.classToToggle);
          }
        }
      });
    }
  }
  customElements.define("class-toggler", ClassToggler);
}
